<template>
  <b-container fluid>
    <h1>CHAMP Log</h1>
    <b-alert show variant="danger" v-if="showAlert">Something went wrong while loading data. Check the console for more info</b-alert>
    <b-col>
      <b-row>
        <b-col class="mb-2">
          <b-form inline @submit="onSubmit">
            <b-form-row>
              <b-form-input v-model="form.num" placeholder="Order ID" class="mx-1" />
              <b-form-input v-model="form.command" placeholder="Command" class="mx-1" />
              <b-form-input v-model="form.start" type="date" placeholder="Started At" class="mx-1" />
              <b-form-input v-model="form.finish" type="date" placeholder="Finished At" class="mx-1" />
              <b-form-checkbox-group v-model="form.selected" :options="checkboxes" />
            </b-form-row>
            <b-form-row>
              <b-btn variant="primary" type="submit">Refresh</b-btn>
            </b-form-row>
          </b-form>
        </b-col>
        <b-col cols=3>
          <b-pagination v-model="page" :per-page="perPage" :total-rows="count" class="pr-1" @change="getData" />
        </b-col>
      </b-row>
      <b-row>
        <b-table :items=items :fields="fields" striped :busy="loading">
          <template slot="SoNumber" slot-scope="row">
            <router-link :to="'/sales-order/view/' + row.item.SoNumber" target="_blank" v-if="row.item.SoNumber != 'NONE'">
              {{ row.item.SoNumber }}
            </router-link>
            <div v-else>
              {{row.item.SoNumber}}
            </div>
          </template>
          <template slot="Error" slot-scope="row">
            {{row.item.Error || row.item.ErrorCode != 1000 ? 'True' : 'False'}}
          </template>
          <template slot="UnixStartStamp" slot-scope="row">
            <nice-date :value="row.item.UnixStartStamp.toString()" />
          </template>
          <template slot="UnixFinishStamp" slot-scope="row">
            <nice-date :value="row.item.UnixFinishStamp.toString()" />
          </template>
          <template slot='Details' slot-scope='row'>
            <b-btn variant=secondary @click="row.toggleDetails">
              {{row.detailsShowing ? 'Hide' : 'Show'}} Details
            </b-btn>
          </template>
          <template slot='row-details' slot-scope='row'>
            <b-row>
              <b-col>
                <b-card>
                  <b-card-title>Arguments</b-card-title>
                  <b-card-body>
                    <expandable-details :id="row.index" :text=row.item.Command />
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col>
                <b-card>
                  <b-card-title>Response</b-card-title>
                  <b-card-body>
                    <expandable-details :id="row.index" :text=row.item.Response />
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </template>
        </b-table>
      </b-row>
    </b-col>
  </b-container>
</template>

<script>
import { FingerprintSpinner } from 'epic-spinners';
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import ExpandableDetails from './ExpandableDetails';
import NiceDate from '../utility/NiceDate';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    FingerprintSpinner,
    ExpandableDetails,
    NiceDate,
  },
  data() {
    return {
      perPage: 20,
      page: 1,
      count: 0,
      fields: [
        'SoNumber',
        { key: 'CommandId', label: 'Command' },
        { key: 'Identifier', label: 'Client Computer' },
        'Error',
        { key: 'Test', label: 'Test Command?' },
        { key: 'UnixStartStamp', label: 'Started At' },
        { key: 'UnixFinishStamp', label: 'Finished At' },
        'Priority',
        'Received',
        'Processed',
        'Details'
      ],
      items: null,
      loading: true,
      showAlert: true,
      form: {
        num: null,
        command: null,
        start: null,
        end: null,
        priority: null,
        selected: ['nonerror', 'test', 'processed', 'received'],
      },
      checkboxes: [
        { text: 'Show Non-Errors', value: 'nonerror' },
        { text: 'Show Test Commands', value: 'test' },
        { text: 'Show Finished Commands', value: 'processed' },
        { text: 'Show Received Commands', value: 'received' },
      ],
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(page) {
      if (page !== undefined) this.page = page;
      this.loading = true;
      this.showAlert = false;
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        data: this.form,
        url: `${BASE_API}/champ/log/${this.page-1}/${this.perPage}`,
      }).then(response => {
        this.count = response.data.count;
        this.items = response.data.results;
        this.items.forEach(item => {
          if (item.ErrorCode != 1000 || item.Error) item._rowVariant = 'danger';
          else if (item.ErrorCode == 1000) item._rowVariant = 'success';
        })
        this.loading = false;
      }).catch(error => {
        console.error(error);
        this.showAlert = true;
        this.loading = false;
      })
    },
    onSubmit(event) {
      event.preventDefault();
      this.page = 1;
      this.getData();
    },
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/it-info/CHAMPTasks.vue